import { put, select, takeEvery } from 'redux-saga/effects'

import { schedule, inventory } from '../../services'
import { selectSailAfterAllInventoriesFetch } from './selections'

const { fetchSailsForLegAndDate } = schedule.actions
const { fetchInventoryAction, changeDate } = inventory.actions

const { FETCH_SCHEDULE_SUCCESS, SW_SAILS_FETCH_SUCCESS } = schedule.constants
const { ALL_INVENTORY_FETCH_SUCCESS, SET_ALL_INVENTORY_FETCH_SUCCESS } = inventory.consts

export function* fetchSailsAndInventories({ sailPackage: { legSequence, code } = {}, dateSelector, ...payload }) {
  let date

  if (!legSequence) return

  const [leg] = legSequence

  if (payload.departureDate) {
    date = payload.departureDate
  } else if (dateSelector) {
    date = yield select(dateSelector)
  }

  if (date) {
    const params = { leg: leg.code, date, code, ...payload }

    yield put(fetchSailsForLegAndDate(params))
    yield put(fetchInventoryAction(params))
  }
}

export function* fetchAllInventory(action) {
  yield put(changeDate(action.payload))
}

export function* watchInventoriesFetch() {
  yield takeEvery(ALL_INVENTORY_FETCH_SUCCESS, selectSailAfterAllInventoriesFetch)
  yield takeEvery(SET_ALL_INVENTORY_FETCH_SUCCESS, selectSailAfterAllInventoriesFetch)
  yield takeEvery(FETCH_SCHEDULE_SUCCESS, selectSailAfterAllInventoriesFetch)
  yield takeEvery(SW_SAILS_FETCH_SUCCESS, selectSailAfterAllInventoriesFetch)
}

export default function* reservation() {
  yield [watchInventoriesFetch()]
}
